const combine = {
    'client.feeds.combine.combine': 'Combineerbare velden',
    'client.feeds.combine.draganddrop': 'Versleep de velden om te combineren',

    'client.feeds.combine.message': 'Let erop dat verkoopprijs of inkoopprijs gekoppeld is',

    'client.feeds.combine.columns.name': 'Naam',
    'client.feeds.combine.columns.manufacturer': 'Merk',
    'client.feeds.combine.columns.category': 'Categorie',
    'client.feeds.combine.columns.price': 'Verkoopprijs',
    'client.feeds.combine.columns.unique_code': 'Artikelnummer',
    'client.feeds.combine.columns.ean': 'EAN',
    'client.feeds.combine.columns.height': 'Hoogte',
    'client.feeds.combine.columns.width': 'Breedte',
    'client.feeds.combine.columns.length': 'Lengte',
    'client.feeds.combine.columns.weight': 'Gewicht',
    'client.feeds.combine.columns.description': 'Omschrijving',
    'client.feeds.combine.columns.image': 'Afbeelding',
    'client.feeds.combine.columns.manufacturer_code': 'Merk artikelnummer',
    'client.feeds.combine.columns.order_number': 'Bestelnummer',
    'client.feeds.combine.columns.in_stock': 'In voorraad',
    'client.feeds.combine.columns.amount_in_stock': 'Aantal in voorraad',
    'client.feeds.combine.columns.tax_class_id': 'BTW-klasse',
    'client.feeds.combine.columns.purchase_price': 'Inkoopprijs',
    'client.feeds.combine.columns.regulation_price': 'Reguliere prijs',
    'client.feeds.combine.columns.variant': 'Variant',
    'client.feeds.combine.columns.related': 'Gerelateerd',
    'client.feeds.combine.columns.cross_sell': 'Cross Sell\'s',
    'client.feeds.combine.columns.clearance_sale': 'Nabestelbaar',
    'client.feeds.combine.columns.restock_time': 'Opvultijd',
    'client.feeds.combine.columns.delivery_time': 'Levertijd',

    'clients.feeds.combine.columns.shopware_6_only': 'Alleen voor shopware 6',

    'client.feeds.combine.columns.price-purchase': 'Verkoopprijs of Inkoopprijs',

    'client.feeds.combine.complete': 'Combinaties opslaan',
    'client.feeds.combine.required': 'Het veld `%field%` dient gekoppeld te worden voor een correcte werking.',
};

export default combine;
